import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { experimentalStyled as styled } from "@mui/material/styles";
import {
  Badge,
  Divider,
  IconButton,
  MenuItem,
  Paper,
  Tooltip,
  Typography,
  Button,
  Modal,
} from "@mui/material";
import Logo from "../assets/Logo.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ViewCompactIcon from "@mui/icons-material/ViewCompact";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

import { updateUser } from "../actions/user";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

export default function Header() {
  const [anchorElUser1, setAnchorElUser1] = React.useState(null);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const handleOpenUserMenu1 = (event) => {
    setAnchorElUser1(event.currentTarget);
  };
  const handleCloseUserMenu1 = () => {
    setAnchorElUser1(null);
  };

  const [anchorElUser2, setAnchorElUser2] = React.useState(null);
  const handleOpenUserMenu2 = (event) => {
    setAnchorElUser2(event.currentTarget);
  };
  const handleCloseUserMenu2 = () => {
    setAnchorElUser2(null);
  };
  const [ModalOpen, setModalOpen] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    dispatch(updateUser(user?.results._id, { login: "no", system: "none" }));
    setTimeout(() => {
      dispatch({ type: "LOGOUT" });
      navigate("/advice/login");
    }, 2000);
  };

  const handleClose = () => {
    setModalOpen(false);
  };
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    textAlign: "center",
  }));

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Modal
        open={ModalOpen}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={style}
          style={{ backgroundColor: "#dfdfdf" }}
          className='animate__animated animate__pulse'>
          <Typography id='modal-modal-title' variant='h6' component='h2'>
            Logout Confirmation
          </Typography>
          <Typography style={{ marginTop: "10px", fontWeight: "bold" }}>
            {user?.results.firstName + " " + user?.results.lastName}
          </Typography>
          <Typography
            id='modal-modal-description'
            sx={{ mt: 2, marginBottom: "20px" }}>
            Are You Sure You Want To Exit?
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}>
            <Button
              style={{ backgroundColor: "#011B39" }}
              onClick={logout}
              size='small'
              variant='contained'>
              Yes <CheckIcon />
            </Button>
            <Button
              color='error'
              className='btn-danger'
              size='small'
              onClick={handleClose}
              variant='contained'>
              CANCEL <CancelIcon />
            </Button>
          </div>
        </Box>
      </Modal>
      <AppBar
        elevation={2}
        position='fixed'
        style={{
          backgroundColor: "#fff",
        }}>
        <Box
          style={{
            marginTop: "7px",
            marginLeft: 240,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginTop: "-15px",
            }}>
            <img width={40} height={"auto"} src={Logo} alt='src logo' />
            <Typography
              variant='h5'
              style={{
                color: "#011b39",
                fontWeight: "bold",
                marginLeft: "10px",
                marginRight: "10px",
                fontSize: "22px",
              }}>
              Bosome Freho Rural Bank PLC
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-around",
            }}>
            <Tooltip title='sFass Apps'>
              <IconButton onClick={handleOpenUserMenu2}>
                <ViewCompactIcon
                  style={{ fontSize: "30px", color: "#011B39" }}
                />
              </IconButton>
            </Tooltip>
            <Badge color='secondary' badgeContent={0} max={100}>
              <Tooltip title='Toggle notifications panel'>
                <IconButton onClick={handleOpenUserMenu1}>
                  <NotificationsIcon style={{ color: "#011B39" }} />
                </IconButton>
              </Tooltip>
            </Badge>
            <Typography>
              <strong style={{ color: "#F5AF14", fontSize: "18px" }}>
                BRB.
              </strong>
              <em style={{ color: "#011B39" }}>Advice</em>
            </Typography>
          </div>
        </Box>
        <Menu
          sx={{ mt: "45px" }}
          id='menu-appbar'
          anchorEl={anchorElUser1}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser1)}
          onClose={handleCloseUserMenu1}>
          <MenuItem style={{ display: "flex", flexDirection: "column" }}>
            <Typography>Notifications</Typography>
          </MenuItem>
          <Divider />
          <MenuItem style={{ display: "flex", flexDirection: "column" }}>
            <Typography>No messages available</Typography>
          </MenuItem>
        </Menu>
        <Menu
          sx={{ mt: "45px" }}
          id='menu-appbar'
          anchorEl={anchorElUser2}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser2)}
          onClose={handleCloseUserMenu2}>
          <Paper
            elevation={0}
            style={{
              width: "240px",
              padding: "10px",
              overflow: "hidden",
              height: "400px",
            }}>
            <Typography variant='h5'>Apps</Typography>
            <Divider style={{ marginBottom: "40px" }} />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3,1fr)",
                gap: "15px",
              }}>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <Typography>sFasss</Typography>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href='https://BRB.anytechgh.app/assets-register'
                  target='_blank'
                  rel='noreferrer'>
                  Assets Register
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href='https://BRB.anytechgh.app/reconciliation'
                  target='_blank'
                  rel='noreferrer'>
                  Reconciliation
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href='https://BRB.anytechgh.app/stock'
                  target='_blank'
                  rel='noreferrer'>
                  Stock manager
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href='https://BRB.anytechgh.app/investment'
                  target='_blank'
                  rel='noreferrer'>
                  Portfolio Manager
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>

                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href='https://BRB.anytechgh.app/advice'
                  target='_blank'
                  rel='noreferrer'>
                  eAdvice
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>

                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href='https://BRB.anytechgh.app/claim'
                  target='_blank'
                  rel='noreferrer'>
                  eClaim
                </a>
              </Item>
              <Item
                elevation={0}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <IconButton>
                  <AnalyticsIcon />
                </IconButton>
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href='https://BRB.anytechgh.app/insurance'
                  target='_blank'
                  rel='noreferrer'>
                  Risk Manager
                </a>
              </Item>
            </div>
          </Paper>
        </Menu>
      </AppBar>
    </Box>
  );
}
